<template>
  <div class="upload_box" v-loading="upLoading">
    <input type="file" @change="fileChange" :accept="accept" ref="referenceUpload" />
    <slot></slot>
  </div>
</template>

<script>
import { upload, metadata, uploadFileSlicing } from "@/api/upload";
export default {
  name: "Upload",
  props: {
    accept: {
      type: String,
      default: ".xls,.doc,.txt,.pdf",
    },
  },
  data() {
    return {
      val: "",
      reader: {},
      params: {
        checksum: "",
        file_size: 0,
        file_name: "",
        file: null,
        fileData: null,
      },
      multiUploadSize: 5 * 1024 * 1024, //文件大于5m就要使用切片上传
      baseUrl: process.env.VUE_APP_BASE_API,
      udatalist: [],
      upLoading:false,//上传loading
    };
  },

  created() {
    this.reader = new FileReader();
    this.reader.onload = this.readerLoad;
  },
  methods: {
    fileChange(e) {
      let _this = e.target;
      let firstFile = _this.files[0];
      if (firstFile) {
        let fileName = firstFile.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if(!this.accept.includes(lastName.toLowerCase())){
          return this.$message.error('文件格式错误')
        }
        this.params.file_name = firstFile.name;
        this.file = firstFile;
        this.reader.readAsArrayBuffer(firstFile);
      }
      
      // this.readerLoad(this.reader.result)
    },




    // 文件读取操作完成时
    readerLoad(e) {
      this.upLoading=true
      this.$emit('isLoading',true) //开启loading
      let _this = e.target;
      console.log('_this.result',_this.result,this.$md5(_this.result));
      this.params.checksum = this.$md5(_this.result);
      this.params.file_size = _this.result.byteLength;
      if (this.params.file_size > 5 * 1024 * 1024) {
        //文件的实际大小大于5M走断点续传
        metadata({
          file_size: this.params.file_size,
          file_name: this.params.file_name,
          checksum: this.params.checksum,
        }).then((res) => {
          console.log(res);
          this.fileData = res.data;
          this.getJob(0, 0);
        });
      } else {
        // 这里直接上传文件走另外的接口
        let file = this.file;
        let param = new FormData(); //创建form对象
        param.append("files", file); //通过append向form对象添加数据
        upload(param).then((response) => {
          this.upLoading=false
          this.$emit('isLoading',false) //开启loading
          this.$refs.referenceUpload.value = null;
          const { data } = response;
          this.onSuccess(data[0].fileId);
        });
      }
    },

    getJob(i, idx) {
      this.bigFile(i, idx);
    },
    // 大文件切片上传方法
    bigFile(i, idx) {
      let { blockStatus, blockList, blockSize, blockCount } = this.fileData;
      var blockNumber = blockList[i];
      if (i < blockList.length) {
        if (!blockStatus[i]) {
          console.log(idx, idx + blockSize[i])
          var udata = this.reader.result.slice(idx, idx + blockSize[i]);
          // this.udatalist = this.udatalist.concat([udata])
          // console.log('this.udatalist',this.udatalist);
          // console.log(udata, this.udatalist,this.mergeArrayBuffer(this.udatalist),this.$md5(this.mergeArrayBuffer(this.udatalist)));
          var sign = this.$md5(udata);
          var headers = {
            "Content-Type": "application/octet-stream",
            "File-Size": this.params.file_size,
            Checksum: this.params.checksum,
            "Block-Checksum": sign,
            "Block-Number": blockNumber,
          };

          uploadFileSlicing(headers, udata).then((res) => {
            if (res.errorCode === "0000") {
              idx += blockSize[i];
              i += 1;
              console.log('1111',i, idx);
              this.getJob(i, idx);
            }

            if (res.data.success) {
              this.$refs.referenceUpload.value = null;
              const { data } = res;
              this.onSuccess(data.fileId);
            }
            if(res.errorCode != "0000"){
              this.upLoading=false
              this.$message.error('上传失败')
              this.$emit('isLoading',false) //开启loading
            }
          }).catch(err=>{
            this.upLoading=false
            this.$message.error('上传失败')
            this.$emit('isLoading',false) //开启loading
          });
        } else {
          idx += blockSize[i];
          i += 1;
          console.log('1111222',i, idx);
          this.getJob(i, idx);
        }
      }
    },
    mergeArrayBuffer(arrays) {
      let totalLen = 0;
      for (let arr of arrays) {
        totalLen += arr.byteLength;
      }
      let res = new Uint8Array(totalLen)
      let offset = 0
      for (let earr of arrays) {
        for (let arr of [earr]) {
          let uint8Arr = new Uint8Array(arr)
          res.set(uint8Arr, offset)
          offset += arr.byteLength
        }
      }
      return res.buffer
    },

    // 上传成功
    onSuccess(data) {
      this.upLoading=false
      // 把返回值传给父组件
      this.$emit("on-success", data);
    },
  },
};
</script>

<style lang="less" scoped>
.upload_box {
  position: relative;
}

.upload_box>input {
  width: 100px;
  height: 50px;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
}
</style>>